import { Component, OnInit, OnDestroy } from "@angular/core";
import { Subscription } from "rxjs";
import { DatePipe } from "@angular/common";

import { ConfirmationService } from "primeng/api";
import { DialogService } from "primeng/dynamicdialog";
import { SchoolService } from "../../../shared/services/school.service";
import { Table } from "primeng/table";
import { Dropdown } from "primeng/dropdown";

import { UserService } from "../../../shared/services/user.service";

import { DataService_mtacardmanager } from "./shared/data.service";

import { wsMTACardShipmentSchoolParmInfo } from "./shared/wsMTACardShipmentSchoolParmInfo";
import { wsMTACardShipmentSchoolInfo } from "./shared/wsMTACardShipmentSchoolInfo";

import { SchoolInfo } from "./shared/SchoolInfo";

import { MTAStatusComponent } from "./mtastatus/mtastatus.component";

import { ViewChild } from "@angular/core";
import { SchoolselectorService } from "../../schoolselector/schoolselectorservice.service";

@Component({
	selector: "app-root",
	templateUrl: "./mtacardmanager.component.html",
	styleUrls: ["./mtacardmanager.component.css"],
	providers: [ConfirmationService, DialogService],
})
export class MTACardManagerComponent implements OnInit, OnDestroy {
	@ViewChild("mydt") mydt: Table;
	@ViewChild("filterMTACardShipmentStatus", { static: false })
	public filterMTACardShipmentStatus: Dropdown;

	constructor(
		private selectService: SchoolselectorService,
		private datepipe: DatePipe,
		private dataService: DataService_mtacardmanager,
		private userService: UserService,
		private schoolService: SchoolService,
		private confirmationService: ConfirmationService,
		private dialogService: DialogService
	) {}

	//-----------------------------------------------------------------------------------------------------
	//
	//	Globals
	//
	//-----------------------------------------------------------------------------------------------------
	private user: any;
	public isBusy: boolean = false;
	public isShowInfo: boolean = false;

	//	School Selector
	public PreSelectSchoolID: any = -1; // -1 = [no selection]
	public lstSchool: any = [];
	public SelectedSchool: SchoolInfo;

	// Date Range Selector
	public IsShippedWithinLastMonthMode: number = 0;

	//	Shipment List
	public lstMTACardShipment: wsMTACardShipmentSchoolInfo[] = [];
	public SelectedMTACardShipment: wsMTACardShipmentSchoolInfo;

	//
	public isShowShipmentTime: boolean = false;
	public isShowReceivedTime: boolean = false;

	//	Filters
	public lstMTACardShipmentStatuses: any = [];

	public pagefirst: number = 0;
	public pagerows: number = 25;

	subscription: any;
	SchoolSelectShowAll: any = true;
	SchoolSelectShowAllID: any = -1;
	SchoolSelectShowAllText: any = "- Select a School -";

	//-----------------------------------------------------------------------------------------------------
	//
	//	ngOnInit
	//
	//-----------------------------------------------------------------------------------------------------
	ngOnInit() {
		this.user = this.userService.getCurrentUser();

		// this.LoadSchoolList();

		this.subscription = this.selectService.onSchoolChanged().subscribe((school) => {
			// this.SchoolID = school.SchoolID;
			this.onSchoolChange(school);
		});
	}

	//-----------------------------------------------------------------------------------------------------
	//
	//	ngOnDestroy
	//
	//-----------------------------------------------------------------------------------------------------
	ngOnDestroy() {
		this.subscription.unsubscribe();
	}

	//-----------------------------------------------------------------------------------------------------
	//
	//	onToggleInfo
	//
	//-----------------------------------------------------------------------------------------------------
	onToggleInfo() {
		this.isShowInfo = !this.isShowInfo;
	}

	//-----------------------------------------------------------------------------------------------------
	//
	//	onRadioMode1
	//
	//-----------------------------------------------------------------------------------------------------
	onRadioMode1() {
		this.onRefresh();
	}

	//-----------------------------------------------------------------------------------------------------
	//
	//	onRadioMode2
	//
	//-----------------------------------------------------------------------------------------------------
	onRadioMode2() {
		this.onRefresh();
	}

	//-----------------------------------------------------------------------------------------------------
	//
	//	onRefresh
	//
	//-----------------------------------------------------------------------------------------------------
	onRefresh() {
		var IsShippedWithinLastMonth: boolean;

		if (this.IsShippedWithinLastMonthMode == 1) {
			IsShippedWithinLastMonth = true;
		} else {
			IsShippedWithinLastMonth = false;
		}

		let parms: wsMTACardShipmentSchoolParmInfo = {
			SchoolID: this.SelectedSchool.SchoolID,
			IsShippedWithinLastMonth: IsShippedWithinLastMonth,
		};

		this.isBusy = true;
		this.dataService.MTACardShipmentSchoolSelectList(parms).subscribe((data) => this.MTACardShipmentSchoolSelectList_Complete(data));
	}

	//-----------------------------------------------------------------------------------------------------
	//
	//	onRowSelect
	//
	//-----------------------------------------------------------------------------------------------------
	onRowSelect(event) {}

	//-----------------------------------------------------------------------------------------------------
	//
	//	onRowUnselect
	//
	//-----------------------------------------------------------------------------------------------------
	onRowUnselect(event) {
		//
		//	Need to set SelectedMTACardShipment here. We don't unselect when selected.
		//
		this.SelectedMTACardShipment = event.data;
	}

	//-----------------------------------------------------------------------------------------------------
	//
	//	MTACardShipmentSchoolSelectList_Complete
	//
	//-----------------------------------------------------------------------------------------------------
	MTACardShipmentSchoolSelectList_Complete(data: any) {
		this.lstMTACardShipment = data;
		this.SelectedMTACardShipment = null;

		//
		//	Set Filter Lists
		//
		this.lstMTACardShipmentStatuses = Array.from(new Set(this.lstMTACardShipment.map((item: any) => item.MTACardShipmentStatusDesc)));

		//
		//	Reset Filters
		//
		this.onClearFilters();

		//
		//	Reset Sort
		//
		this.mydt.multiSortMeta = [];
		this.mydt.multiSortMeta.push({ field: "ShipmentDT", order: -1 });
		this.mydt.sortMultiple();

		this.isBusy = false;
	}

	//-----------------------------------------------------------------------------------------------------
	//
	//	onClearFilters
	//
	//-----------------------------------------------------------------------------------------------------
	onClearFilters() {
		this.filterMTACardShipmentStatus.clear(null);
	}

	//-----------------------------------------------------------------------------------------------------
	//
	//	onReceive
	//
	//-----------------------------------------------------------------------------------------------------
	onReceive() {
		if (this.SelectedMTACardShipment == null || this.SelectedMTACardShipment.MTACardShipmentStatusID != 6) {
			// Shipped (In-Transit)
			this.confirmationService.confirm({
				acceptLabel: "Ok",
				rejectVisible: false,
				message: "Please select a shipment with a status of '[Shipped (In-Transit)'",
				header: "Receive Shipment",
				icon: "fa fa-info",
				accept: () => {},
				reject: () => {},
			});
		} else {
			var ref = this.dialogService.open(MTAStatusComponent, {
				header: "Receive Shipment",
				width: "435px",
				data: {
					UserPersonID: this.user.personID,
					MTACardShipmentID: this.SelectedMTACardShipment.MTACardShipmentID,
					TotalCards: this.SelectedMTACardShipment.qty,
				},
			});
			ref.onClose.subscribe((response) => {
				if (response == 1) {
					//
					//	Refresh Q
					//
					this.onRefresh();
				}
			});
		}
	}

	//-----------------------------------------------------------------------------------------------------
	//
	//	ontoggleShipmentTime
	//
	//-----------------------------------------------------------------------------------------------------
	ontoggleShipmentTime() {
		this.isShowShipmentTime = !this.isShowShipmentTime;
	}

	//-----------------------------------------------------------------------------------------------------
	//
	//	ontoggleReceivedTime
	//
	//-----------------------------------------------------------------------------------------------------
	ontoggleReceivedTime() {
		this.isShowReceivedTime = !this.isShowReceivedTime;
	}

	//-----------------------------------------------------------------------------------------------------
	//
	//	onHandleFilter
	//
	//-----------------------------------------------------------------------------------------------------
	onHandleFilter(e: any) {}

	//-----------------------------------------------------------------------------------------------------
	//
	//	onHandleSort
	//
	//-----------------------------------------------------------------------------------------------------
	onHandleSort(e: any) {}

	//-----------------------------------------------------------------------------------------------------
	//
	//	LoadSchoolList
	//
	//-----------------------------------------------------------------------------------------------------
	LoadSchoolList() {
		var result = this.schoolService.loadSchoolList("");

		result.subscribe(
			(response) => {
				this.lstSchool = response;
				let isItemFound: boolean = false;
				let isSchoolSelected: boolean = false;

				//
				//	Add the [- Select a school -] to the top of the list
				//
				//	Note: "- Select a school" is put in SchoolNumber to match the HTML formatting.
				//		this allows it to show with a visual appeal that matches the rest of the items.
				//
				this.lstSchool.unshift({
					SchoolID: -1,
					SchoolNumber: "- Select a school",
					SchoolName: "",
				});

				//
				//	if PreSelectSchoolID has a value not equal -1 then try to select the item
				//
				this.lstSchool.forEach((item) => {
					if (this.PreSelectSchoolID == item.SchoolID && isItemFound == false && this.PreSelectSchoolID != -1) {
						this.SelectedSchool = item;
						isItemFound = true;
						isSchoolSelected = true;
					}
				});

				//
				//	if PreSelectSchoolID was not found
				//
				if (isItemFound == false) {
					//
					//	If there is only 1 school in list and (PreSelectSchoolID = -1 or PreSelectSchoolID matched the school)
					//	then select it. otherwise select the [- Select a School -] item.
					//
					if (this.lstSchool.length == 2) {
						if (this.PreSelectSchoolID == -1 || this.PreSelectSchoolID == this.lstSchool[1].SchoolID) {
							this.SelectedSchool = this.lstSchool[1];
							isSchoolSelected = true;
						} else {
							this.SelectedSchool = this.lstSchool[0];
						}
					} else {
						this.SelectedSchool = this.lstSchool[0];
					}
				}

				this.isBusy = false;

				if (isSchoolSelected == true) {
					this.onRefresh();
				}
			},
			(error) => {}
		);
	}

	//-----------------------------------------------------------------------------------------------------
	//
	//	onSchoolChange
	//
	//-----------------------------------------------------------------------------------------------------
	onSchoolChange(value) {
		this.SelectedSchool = value;

		if (this.SelectedSchool.SchoolID > 0) {
			this.onRefresh();
		} else {
			this.lstMTACardShipment = [];
		}
	}

	//-----------------------------------------------------------------------------------------------------
	//
	//	Add New Method Here
	//
	//-----------------------------------------------------------------------------------------------------
}
